var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"top-header"}},[_c('div',{staticClass:"title"},[_c('h1',{staticClass:"mt-8 mb-5"},[_vm._v(_vm._s(_vm.title))])]),_c('div',{staticClass:"desc_container"},[_c('div',{staticClass:"subtitle"}),_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }